<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header">
          <div>
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item class="bold"
                >Cấu hình chấm công</el-breadcrumb-item
              >
              <el-breadcrumb-item>Quản lý kết nối Agent</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
        </div>
        <div class="main-body mt-1">
          <div class="main-body-table">
            <div class="list-agent">
              <b-row>
                <b-col md="6" class="d-flex align-items-end mb-2"
                  ><p>Danh sách thiết bị</p></b-col
                >
                <b-col md="6" class="text-right mb-2">
                  <el-button
                    type="danger"
                    plain
                    class="mr-2"
                    @click="fn_cleanInactiveDevices"
                  >
                    <i class="fas fa-trash-alt mr-1"></i> Dọn dẹp IP rác
                  </el-button>
                  <el-button class="btn-default" @click="fn_reLoadData"
                    >Quét thiết bị</el-button
                  >
                </b-col>
              </b-row>
              <el-table
                :data="dataTable"
                border
                @selection-change="fn_tableSelectionChange"
                @sort-change="fn_tableSortChange"
                style="width: 100%"
                :default-sort="{
                  prop: mData.tableRules.defaultSort[0],
                  order: mData.tableRules.defaultSort[1],
                }"
              >
                <el-table-column
                  type="selection"
                  width="40"
                  v-if="mData.tableRules.allowSelect"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="ip"
                  label="IP"
                  min-width="100"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="isOpen"
                  label="Trạng thái Online"
                  min-width="130"
                >
                  <template slot-scope="scope">
                    {{
                      scope.row.isOpen === true
                        ? "✔️"
                        : scope.row.isOpen === false
                        ? "❌"
                        : ""
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="isActive"
                  label="Trạng thái Active"
                  min-width="130"
                >
                  <template slot-scope="scope">
                    {{
                      scope.row.isActive === true
                        ? "✔️"
                        : scope.row.isActive === false
                        ? "❌"
                        : ""
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="name"
                  label="Tên thiết bị"
                  min-width="160"
                >
                  <template slot-scope="scope" v-if="scope.row.serial">
                    <div class="d-flex justify-content-between align-items-center">
                      <el-popover
                        placement="top-start"
                        trigger="hover"
                        :open-delay="800"
                        :content="scope.row.name">
                        <div slot="reference" class="content"><span>{{ scope.row.name }}</span></div>
                      </el-popover>
                      <i
                        @click="fn_showHideDeviceNameDialog(scope.row, scope.row.id,scope.row.name)"
                        style="font-size: 14px !important; cursor: pointer"
                        class="icon-Pencil ml-2"
                        v-b-popover.hover.left="aLang.c_update"
                      ></i>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  align="center"
                  prop="serial"
                  label="Mã thiết bị"
                  min-width="280"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="password"
                  label="Mật khẩu"
                  min-width="100"
                >
                  <template slot-scope="scope" v-if="scope.row.password">
                    <div v-if="!dataPwDevice[scope.$index].isShowPw">
                      <span>********</span>
                      <i
                        style="cursor: pointer"
                        class="fa fa-eye-slash ml-2"
                        @click="fn_showHidePw(scope.$index, 'show')"
                        v-b-popover.hover.left="aLang.c_view"
                      ></i>
                    </div>
                    <div v-if="dataPwDevice[scope.$index].isShowPw">
                      <span>{{ scope.row.password }}</span>
                      <i
                        style="cursor: pointer"
                        class="fa fa-eye ml-2"
                        @click="fn_showHidePw(scope.$index, 'hide')"
                        v-b-popover.hover.left="aLang.c_hide"
                      ></i>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  align="left"
                  label="Thao tác"
                  :width="!this.isProcessFiveMins ? 200 : 155"
                  v-if="mData.dataDefault.listFeature.includes('FT306')"
                >
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      @click="showHideConfig(scope.row.ip)"
                      v-b-popover.hover.left="aLang.c_config"
                      v-if="mData.dataDefault.listFeature.includes('FT306')"
                    >
                      <i
                        class="el-icon-s-tools"
                        style="transform: rotate(90deg)"
                      ></i>
                    </el-button>
                    <el-button
                      size="mini"
                      @click="fn_syncEmployee(scope.row.ip)"
                      v-b-popover.hover.left="aLang.c_sync"
                      v-if="
                        mData.dataDefault.listFeature.includes('FT306') &&
                        scope.row.serial &&
                        (!scope.row.disabled || scope.row.isOpen)
                      "
                    >
                      <i class="el-icon-refresh"></i>
                    </el-button>
                    <el-button
                      size="mini"
                      @click="fn_getAddedEmployee(scope.row.ip)"
                      v-b-popover.hover.left="aLang.c_view"
                      v-if="
                        mData.dataDefault.listFeature.includes('FT306') &&
                        scope.row.serial
                      "
                    >
                      <i class="el-icon-s-order"></i>
                    </el-button>
                    <el-button
                      size="mini"
                      @click="fn_openDialogDeleteDevice(scope.row)"
                      v-b-popover.hover.left="aLang.c_delete"
                      v-if="mData.dataDefault.listFeature.includes('FT306') && scope.row.isActive && !isProcessFiveMins"
                    >
                      <i
                        class="fas fa-trash-alt"
                      ></i>
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="Cấu hình"
      width="35%"
      :visible.sync="mData.dialogConfig"
      @close="closeDialog"
      :close-on-click-modal="false"
    >
      <el-form
        :model="dataConfig"
        :rules="validDataConfig"
        ref="myForm"
        label-position="top"
        @submit.native.prevent
        label-width="200px"
      >
        <b-row>
          <b-col md="12">
            <el-form-item label="Nhập mật khẩu" prop="pw">
              <el-input
                type="password"
                v-model="dataConfig.pw"
                show-password
                auto-complete="off"
                :disabled="this.isHasPw == true"
              ></el-input>
            </el-form-item>
          </b-col>
          <b-col md="12">
            <el-form-item label="Phương thức kết nối">
              <el-select v-model="dataConfig.connectionMode" style="width: 100%">
                <el-option label="Tự động (SDK 8000 → ISAPI 80/443)" value="auto"></el-option>
                <el-option label="SDK (cổng 8000)" value="sdk"></el-option>
                <el-option label="ISAPI (HTTP/HTTPS 80/443)" value="isapi"></el-option>
              </el-select>
            </el-form-item>
          </b-col>
          <b-col md="12">
            <el-form-item label="Thời gian máy chấm công" prop="timeDevice">
              <el-date-picker
                v-model="dataConfig.timeDevice"
                type="datetime"
                format="dd/MM/yyyy HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
            </el-form-item>
          </b-col>
        </b-row>
        <div class="text-right mb-0">
          <el-button
            type="primary"
            round
            class="btn-default"
            @click="fn_updateDevice()"
            >Cập nhật</el-button
          >
        </div>
      </el-form>
    </el-dialog>
    <el-dialog
      class="dialog-employee"
      title="Danh sách nhân viên"
      width="50%"
      :visible.sync="mData.dialogAddedEmployees"
      :close-on-click-modal="false"
      :before-close="fn_backToDefault"
    >
      <el-table
        :data="dataAddedEmployees"
        border
        @selection-change="fn_tableSelectionChange"
        @sort-change="fn_tableSortChange"
        style="width: 100%"
        height="500"
        :default-sort="{
          prop: mData.tableRules.defaultSort[0],
          order: mData.tableRules.defaultSort[1],
        }"
      >
        <el-table-column prop="" label="STT" width="50">
          <template slot-scope="scope">
            <div class="text-center">
              {{ mData.tableRules.offset + scope.$index + 1 }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="FaceImageId"
          label="Ảnh"
          width="150"
        >
          <template slot-scope="scope">
            <div class="text-center">
              <el-image
                style="width: 100px; height: 100px"
                :src="ExtensionService.urlImg + scope.row.FaceImageId"
                fit="cover"
              ></el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="CardNo"
          label="Mã nhân viên"
          min-width="250"
        >
          <template slot-scope="scope">
            <div class="text-center">
              {{
                scope.row.CardNo ?
                scope.row.CardNo : ''
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="Name"
          label="Họ và tên"
          min-width="250"
        ></el-table-column>
      </el-table>
      <div class="text-right mt-2" v-if="mData.tableRules.allowPaging">
        <el-pagination
          @size-change="fn_tableSizeChange"
          @current-change="fn_tableCurentChange"
          @prev-click="fn_tablePrevClick"
          @next-click="fn_tableNextClick"
          :page-sizes="mData.tableRules.lengthMenu"
          :page-size="mData.tableRules.limit"
          :current-page="Number(mData.tableRules.page)"
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="mData.tableRules.total"
          :pager-count="5"
        ></el-pagination>
      </div>
    </el-dialog>
    <!-- Dialog update Device's name -->
    <el-dialog
      title="Cập nhật tên thiết bị"
      width="30%"
      :visible.sync="mData.dialogUpdateDeviceName"
      :close-on-click-modal="false"
    >
      <el-form
        :model="dataConfigDeviceName"
        :rules="validConfigDeviceName"
        ref="formRenameDevice"
        label-position="left"
        @submit.native.prevent
        label-width="105px"
      >
        <b-row>
          <b-col md="12">
            <el-form-item label="Tên thiết bị" prop="name">
              <el-input
                type="text"
                v-model="dataConfigDeviceName.name"
                auto-complete="off"
              ></el-input>
            </el-form-item>
            <div slot="footer" class="text-center mb-0">
              <el-button
                type="primary"
                class="btn-default mt-1"
                @click="fn_updateDeviceName()"
                >Lưu</el-button
              >
            </div>
          </b-col>
        </b-row>
      </el-form>
    </el-dialog>
    <!-- Button cancel when loading get data devices -->
    <div class="btnCancel" v-if="isGetcommandHasData == false">
      <el-button
        type="danger"
        plain
        round
        class="btn-back"
        @click="fn_cancelGetDataDevices()"
        >Hủy</el-button
      >
    </div>

    <!-- Dialog Warning when click delete -->
    <el-dialog
      :visible.sync="dialogDeleteDevice"
      :show-close="false"
      :close-on-click-modal="false"
      width="400px"
      center
      class="dialog-warning"
    >
      <div class="text-center">
        <img class="m-2" src="img/warning-agent.png" alt="Warning picture here!">
      </div>
      <div class="text-center font-lg bold-500 mt-2 mb-3">Bạn có chắc chắn muốn xóa thiết bị này không?</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogDeleteDevice = false" class="btn-back">Hủy</el-button>
        <el-button @click="fn_deleteDevice(idRecordDelete)" class="btn-default">Đồng ý</el-button>
      </span>
    </el-dialog>

    <Loading v-if="isGetcommandHasData == false" />
  </div>
</template>

<script>
import ExtensionService from '../../../../../service/ExtensionService';
import LanguageService from "../../../../../service/LanguageService";
import ValidService from "../../../../../service/ValidService";
import MethodService from "../../../../../service/MethodService";
import AgentModel from "./AgentModel";
import CommandQueueApi from "../../../../../moduleApi/CommandQueueApi";
import DeviceApi from "../../../../../moduleApi/DeviceApi";
import EmployeeApi from "../../../../../moduleApi/EmployeeApi";
import Loading from "../../../../../component/Loading";
export default {
  components: {
    Loading,
  },
  data() {
    return {
      ExtensionService,
      resolvedAgentId: "",
      dataConfig: {
        pw: "",
        timeDevice: "",
        connectionMode: "auto",
      },
      validDataConfig: {
        pw: [ValidService.required],
        timeDevice: [ValidService.required],
      },
      dataConfigDeviceName: {
        id: "",
        name: "",
      },
      validConfigDeviceName: {
        name: [ValidService.required, ValidService.checkSpaceString],
      },
      momentStartGetDeviceTime: "",
      momentEndGetDeviceTime: "",
      isSuccess: false,
      isShowPw: false,
      isHasPw: false,
      isGetcommandHasData: undefined,
      dataDevice: undefined,
      timePushDataDevice: "",
      aLang: LanguageService.lang,
      timeOutNoData: undefined,
      timeOutNoDataTimePush: false,
      dataPwDevice: [],
      dataTable: [],
      dataAllDevices: [],
      mData: {
        ipDeviceConfig: undefined,
        dataCommandQueue: [],
        dialogConfig: false,
        dialogSettingAgent: false,
        dialogAddedEmployees: false,
        dialogUpdateDeviceName: false,
        moduleName: "AgentConnectionManagement", //requied
        tableRules: MethodService.copyObject(AgentModel.tableRules),
        dataForm: MethodService.copyObject(AgentModel.dataForm),
        dataFormOther: MethodService.copyObject(AgentModel.dataFormOther),
        dataFormGetAddedEmployee: MethodService.copyObject(
          AgentModel.dataFormGetAddedEmployee
        ),
        dataForm1: MethodService.copyObject(AgentModel.dataForm1),
        dataForm2: MethodService.copyObject(AgentModel.dataForm2),
        validForm: AgentModel.validForm,
        refreshGetResult: "",
        refreshGetResultTable: "",
        refreshGetTimePushDataResult: "",
        refreshGetAddedEmployees: "",
        refreshGetResultAddPw: "",
        refreshGetResultSetDeviceTime: "",
        dataDefault: {
          listFeature: MethodService.getListFeatures(),
          currentCompany: MethodService.getCompanyInfo(),
        },
      },
      dataAddedEmployees: [],
      dataPerPage: [],
      ip: "",
      clicked: false,
      listDataPerPage: [],
      deviceName: undefined,
      configPasswordStatus: false,
      configTimeDeviceStatus: false,
      setTimeoutGetResultTable: "",
      dataAddDevice: {},
      intervalGetListDevice: "",
      dialogDeleteDevice: false,
      idRecordDelete: '',
      isErrorAddPasswordCommandQueue: false,
      isProcessFiveMins: false
    };
  },

  methods: {
    fn_cleanInactiveDevices() {
      const beforeCount = this.dataTable.length;
      this.dataTable = this.dataTable.filter((item) => {
        const hasPassword = item.password && item.password.trim() !== "";
        const isActive = item.isActive === true || item.is_active === true;
        const isOnline = item.isOpen === true || item.is_open === true;

        // Giữ lại nếu: Có nhập pass OR (Cả Active và Online đều bật ✔️)
        return hasPassword || (isActive && isOnline);
      });
      const removedCount = beforeCount - this.dataTable.length;
      if (removedCount > 0) {
        window.toastr.success(
          `Đã dọn dẹp ${removedCount} địa chỉ IP rác khỏi danh sách!`
        );
      } else {
        window.toastr.info("Không có địa chỉ IP rác nào cần dọn dẹp.");
      }
    },

    async fn_resolveAgentId() {
      const route = this.$router && this.$router.currentRoute;
      const paramId = route && (route.params.id || route.params.agent_id || route.query.id || route.query.agent_id);
      if (paramId) {
        this.resolvedAgentId = paramId;
        return paramId;
      }
      throw new Error("Missing agent_id in AgentConnectionManagement route");
    },

    getAgentId() {
      const route = this.$router && this.$router.currentRoute;
      const paramId = route && (route.params.id || route.params.agent_id || route.query.id || route.query.agent_id);
      return paramId || this.resolvedAgentId;
    },

    async fn_getListDevice() {
      try {
        await this.fn_resolveAgentId();
        const currentAgentId = this.getAgentId();
        const deviceApiRes = await DeviceApi.list({
          filters: "agent_id=" + currentAgentId,
          sort: "-created_at"
        });
        const _ = require("lodash");
        if (deviceApiRes && deviceApiRes.result) {
          const rawDevices = deviceApiRes.result || [];
          this.dataAllDevices = rawDevices.map(item => ({
            ...item,
            isOpen: item.disabled ? false : (item.is_active ? true : false),
            isActive: item.is_active || false
          }));

          const uniqueList = _.uniqBy(this.dataAllDevices, "ip");
          this.dataTable = uniqueList.filter(item => {
            const hasPassword = item.password && item.password.trim() !== "";
            const hasSerial = item.serial && item.serial.trim() !== "";
            const isActive = item.isActive === true || item.is_active === true;
            const isOnline = item.isOpen === true || item.is_open === true;
            return isOnline || hasPassword || hasSerial || isActive;
          });
        }
      } catch (error) {
        console.error("fn_getListDevice error:", error);
      }
    },

    async fn_commandGetDataTable() {
      this.mData.dataFormOther.command = "GetListDevices";
      this.mData.dataFormOther.agent_id = this.getAgentId();
      this.mData.dataFormOther.params = [];
      const commandDetail = this.mData.dataFormOther;
      const idCommandRes = await CommandQueueApi.create(commandDetail, true);
      await this.fn_initTable(idCommandRes.result);
    },

    async fn_initTable(id) {
      try {
        // Luôn đi qua cùng một nhánh xử lý/merge kết quả. Agent có thể trả lời
        // ngay trước lần kiểm tra đầu tiên; trước đây trường hợp đó chỉ bật cờ
        // thành công và vẫn giữ danh sách thiết bị lấy từ DB.
        this.fn_startIntervalGetDataDevice(id);
      } catch (error) {
        clearInterval(this.mData.refreshGetResultTable);
        this.isGetcommandHasData = true;
      }
    },

    async fn_findByIdCommandGet(id) {
      this.isGetcommandHasData = false;
      CommandQueueApi.clearCache();
      const data = await CommandQueueApi.findById(
        {
          id,
          fields:
            "id,command,company_id,agent_id,params,is_success,result,created_at,updated_at",
        },
        true
      );
      if (data.result && data.result.result) {
        this.isGetcommandHasData = true;
      }
      return data;
    },

    async fn_waitForCommand(id, timeoutMs = 35000) {
      const startTime = Date.now();
      while (Date.now() - startTime < timeoutMs) {
        try {
          const res = await this.fn_findByIdCommandGet(id);
          if (res && res.result && res.result.result != null) {
            return res.result;
          }
        } catch (err) {
          // ignore transient poll error
        }
        await new Promise(resolve => setTimeout(resolve, 2000));
      }
      return null;
    },

    async fn_getTimeDevice() {
      this.mData.dataForm.params = [];
      this.mData.dataFormOther.command = "GetDataTime";
      this.mData.dataFormOther.agent_id = this.getAgentId();
      const commandDetail = this.mData.dataFormOther;
      const idCommandRes = await CommandQueueApi.create(commandDetail, true);
      try {
        const res = await this.fn_findByIdCommandGet(idCommandRes.result);
        if (!res || !res.result.result) {
          this.fn_startIntervalGetTimePushData(idCommandRes.result);
        }
      } catch (error) {
        clearInterval(this.mData.refreshGetTimePushDataResult);
        window.toastr.error("Có lỗi khi lấy thời gian đẩy công !");
        this.isGetcommandHasData = true;
      }
    },

    async fn_startIntervalGetTimePushData(id) {
      const _this = this.mData;
      _this.refreshGetTimePushDataResult = setInterval(async () => {
        try {
          const commandQueueApiRes = await this.fn_findByIdCommandGet(id);
          if (commandQueueApiRes.result.result != null) {
            this.timePushDataDevice = JSON.parse(
              commandQueueApiRes.result.result
            ).Result;
            this.mData.validForm.params = [];
            this.timePushDataDevice.forEach((el) => {
              const o = {
                timePushData: el,
              };
              const oValid = {
                timePushData: [ValidService.required],
              };
              this.mData.dataForm.params.push(o);
              this.mData.validForm.params.push(oValid);
            });
          }
        } catch (error) {
          clearInterval(_this.refreshGetTimePushDataResult);
          window.toastr.error("Có lỗi khi lấy thời gian đẩy công !");
          this.isGetcommandHasData = true;
        }
      }, 3000);
    },

    async fn_startIntervalGetDeviceTime(id) {
      let commandQueueApiRes;
      const _this = this.mData;
      _this.refreshGetResult = setInterval(async () => {
        try {
          commandQueueApiRes = await this.fn_findByIdCommandGet(id);
          if (commandQueueApiRes.result.result != null) {
            this.dataDevice = commandQueueApiRes.result;
          }
        } catch (error) {
          clearInterval(_this.refreshGetResult);
          window.toastr.error("Có lỗi khi lấy thời gian thiết bị !");
          this.isGetcommandHasData = true;
        }
      }, 3000);
    },

    async fn_startIntervalGetDataDevice(id) {
      let commandQueueApiRes;
      const _this = this.mData;
      _this.refreshGetResultTable = setInterval(async () => {
        try {
          commandQueueApiRes = await this.fn_findByIdCommandGet(id);
          if (commandQueueApiRes && commandQueueApiRes.result && commandQueueApiRes.result.result != null) {
            this.isSuccess = true;
            clearInterval(_this.refreshGetResultTable);

            let agentDevices = [];
            try {
              const parsed = JSON.parse(commandQueueApiRes.result.result);
              agentDevices = parsed.Result || [];
            } catch (e) {
              agentDevices = [];
            }

            // Merge thông tin quét từ Agent với Database server
            const dbList = this.dataAllDevices || [];
            const mergedList = agentDevices.map(device => {
              const devIp = device.ip ? device.ip.trim() : "";
              const devSerial = device.serial ? device.serial.trim() : "";

              const matchedDb = dbList.find(dbItem => {
                const itemIp = dbItem.ip ? dbItem.ip.trim() : "";
                const itemSerial = dbItem.serial ? dbItem.serial.trim() : "";
                return (itemIp && devIp && itemIp === devIp) || (itemSerial && devSerial && itemSerial === devSerial);
              });

              const isOnline = device.isOpen === true;
              const hasDbActive = matchedDb ? (matchedDb.isActive === true || matchedDb.is_active === true) : false;
              const isActive = device.isActive === true || hasDbActive;
              const password = (device.password && device.password.trim() !== "")
                ? device.password
                : (matchedDb && matchedDb.password ? matchedDb.password : "");
              const serial = (device.serial && device.serial.trim() !== "")
                ? device.serial
                : (matchedDb && matchedDb.serial ? matchedDb.serial : "");
              const name = (matchedDb && matchedDb.name) || device.name || "";

              return {
                id: (matchedDb && matchedDb.id) || device.id || "",
                ip: devIp,
                name: name,
                serial: serial,
                password: password,
                isOpen: isOnline,
                isActive: isActive,
                is_active: isActive,
                disabled: !isOnline
              };
            });

            // Giữ lại các thiết bị đã có trong DB nếu Agent tạm thời không scan thấy
            dbList.forEach(dbItem => {
              const itemIp = dbItem.ip ? dbItem.ip.trim() : "";
              const itemSerial = dbItem.serial ? dbItem.serial.trim() : "";
              const exists = mergedList.some(m =>
                (itemIp && m.ip && m.ip === itemIp) ||
                (itemSerial && m.serial && m.serial === itemSerial)
              );
              if (!exists && itemIp) {
                mergedList.push({
                  ...dbItem,
                  isOpen: false,
                  disabled: true
                });
              }
            });

            // Lọc các bản ghi hợp lệ
            this.dataTable = mergedList.filter(item => {
              const hasPassword = item.password && item.password.trim() !== "";
              const hasSerial = item.serial && item.serial.trim() !== "";
              const isActive = item.isActive === true || item.is_active === true;
              const isOnline = item.isOpen === true || item.is_open === true;
              return isOnline || hasPassword || hasSerial || isActive;
            });

            this.isGetcommandHasData = true;
          }
        } catch (error) {
          clearInterval(_this.refreshGetResultTable);
          this.isGetcommandHasData = true;
        }
      }, 3000);
    },

    async fn_startIntervalGetResultAddPw(id) {
      const _this = this.mData;
      _this.refreshGetResultAddPw = setInterval(async () => {
        try {
          const commandQueueApiRes = await this.fn_findByIdCommandGet(id);
          if (commandQueueApiRes.result.result != null && !commandQueueApiRes.result.result.includes('code : 153')) {
            clearInterval(_this.refreshGetResultAddPw);
            const addPwStatus = commandQueueApiRes.result.is_success;
            if(addPwStatus) {
              this.configPasswordStatus = true;
            }
          } else if (commandQueueApiRes.result.result != null && commandQueueApiRes.result.result.includes('code : 153')) {
            clearInterval(_this.refreshGetResultAddPw);
            this.isErrorAddPasswordCommandQueue = true;
          }
        } catch (error) {
          clearInterval(_this.refreshGetResultAddPw);
          this.isGetcommandHasData = true;
        }
      }, 3000);
    },

    async fn_startIntervalGetResultSetDeviceTime(id) {
      const _this = this.mData;
      _this.refreshGetResultSetDeviceTime = setInterval(async () => {
        try {
          const commandQueueApiRes = await this.fn_findByIdCommandGet(id);
          if (commandQueueApiRes.result.result != null) {
            clearInterval(_this.refreshGetResultSetDeviceTime);
            const setDeviceTimeStatus = commandQueueApiRes.result.is_success;
            if(setDeviceTimeStatus) {
              this.configTimeDeviceStatus = true;
            }
          }
        } catch (error) {
          clearInterval(_this.refreshGetResultSetDeviceTime);
          this.isGetcommandHasData = true;
        }
      }, 3000);
    },

    async fn_startIntervalGetDataAddedEmployees(id) {
      let commandQueueApiRes;
      const _this = this.mData;
      _this.refreshGetAddedEmployees = setInterval(async () => {
        try {
          commandQueueApiRes = await this.fn_findByIdCommandGet(id);
          if (commandQueueApiRes.result.result != null) {
            this.dataAddedEmployees = JSON.parse(
              commandQueueApiRes.result.result
            ).Result.listEmployee[0].userInfos;
            if (typeof Storage !== "undefined") {
              sessionStorage.setItem(
                "limit=" +
                  this.mData.tableRules.limit +
                  "-page=" +
                  this.mData.tableRules.page +
                  "-ip=" +
                  this.ip,
                JSON.stringify(this.dataAddedEmployees)
              );
              this.listDataPerPage.push(
                "limit=" +
                  this.mData.tableRules.limit +
                  "-page=" +
                  this.mData.tableRules.page +
                  "-ip=" +
                  this.ip
              );
            }
            this.mData.tableRules.total = JSON.parse(
              commandQueueApiRes.result.result
            ).Result.listEmployee[0].total;
            this.isSuccess = JSON.parse(
              commandQueueApiRes.result.result
            ).IsSuccess;
          }
        } catch (error) {
          clearInterval(_this.refreshGetAddedEmployees);
          this.isGetcommandHasData = true;
        }
      }, 3000);
    },
    // Config device
    async showHideConfig(ip) {
      if (this.isProcessFiveMins) {
        clearInterval(this.refreshGetResultTable);
        this.refreshGetDataDevice();
      }
      this.mData.ipDeviceConfig = ip;
      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "Admin-Timekeeping-TimekeepingConfig-AgentConnectionManagement",
            query: {
              ip: ip,
            },
          })
          .catch((err) => {
            // console.log(err);
          });
      }
      const deviceChosen = this.dataTable.find((device) => {
        return device.ip == ip;
      });
      let resDataTimeDevice = "";
      if (
        (deviceChosen.isOpen == true && deviceChosen.password && deviceChosen.password !== "") ||
        deviceChosen.isActive == true
      ) {
        if (this.dataConfig.pw || this.dataConfig.timeDevice) {
          this.fn_resetForm("myForm");
        }
        this.isHasPw = true;
        this.dataConfig.pw = deviceChosen.password || "";

        // Lấy thời gian máy chấm công
        this.mData.dataFormOther.agent_id = this.getAgentId();
        this.mData.dataFormOther.command = "GetDeviceTime";
        this.mData.dataFormOther.params = [this.mData.ipDeviceConfig];
        const commandGetDeviceTime = this.mData.dataFormOther;

        this.momentStartGetDeviceTime = new Date().getTime();

        const commandGetDeviceTimeApiRes = await CommandQueueApi.create(
          commandGetDeviceTime
        );
        resDataTimeDevice = await this.fn_findByIdCommandGet(
          commandGetDeviceTimeApiRes.result
        );
        if (!resDataTimeDevice || !resDataTimeDevice.result.result) {
          this.fn_startIntervalGetDeviceTime(commandGetDeviceTimeApiRes.result);
        }
      } else if (deviceChosen.isOpen == true && (!deviceChosen.password || deviceChosen.password == "")) {
        this.mData.dialogConfig = true;
        this.isHasPw = false;
        if (this.dataConfig.pw || this.dataConfig.timeDevice) {
          this.fn_resetForm("myForm");
        }
        const now = new Date();
        const yyyy = now.getFullYear();
        const mm = String(now.getMonth() + 1).padStart(2, '0');
        const dd = String(now.getDate()).padStart(2, '0');
        const hh = String(now.getHours()).padStart(2, '0');
        const min = String(now.getMinutes()).padStart(2, '0');
        const ss = String(now.getSeconds()).padStart(2, '0');
        this.dataConfig.timeDevice = `${yyyy}-${mm}-${dd} ${hh}:${min}:${ss}`;
      } else if (deviceChosen.isOpen == false) {
        window.toastr.error("Thiết bị đang chưa hoạt động !");
      }
    },
    // configuration for each device
    async fn_updateDevice() {
      this.$refs["myForm"].validate(async (valid) => {
        if (!valid) {
          MethodService.stopLadda();
          return false;
        }

        const ip = this.mData.ipDeviceConfig;
        const pw = this.dataConfig.pw;
        const rawTime = this.dataConfig.timeDevice;
        this.isGetcommandHasData = false;

        let formattedTime = "";
        if (rawTime instanceof Date) {
          const yyyy = rawTime.getFullYear();
          const mm = String(rawTime.getMonth() + 1).padStart(2, '0');
          const dd = String(rawTime.getDate()).padStart(2, '0');
          const hh = String(rawTime.getHours()).padStart(2, '0');
          const min = String(rawTime.getMinutes()).padStart(2, '0');
          const ss = String(rawTime.getSeconds()).padStart(2, '0');
          formattedTime = `${yyyy}-${mm}-${dd} ${hh}:${min}:${ss}`;
        } else if (typeof rawTime === 'string' && rawTime.trim() !== '') {
          formattedTime = rawTime.trim();
        } else {
          const now = new Date();
          const yyyy = now.getFullYear();
          const mm = String(now.getMonth() + 1).padStart(2, '0');
          const dd = String(now.getDate()).padStart(2, '0');
          const hh = String(now.getHours()).padStart(2, '0');
          const min = String(now.getMinutes()).padStart(2, '0');
          const ss = String(now.getSeconds()).padStart(2, '0');
          formattedTime = `${yyyy}-${mm}-${dd} ${hh}:${min}:${ss}`;
        }

        if (!this.isHasPw) {
          // Bước 1: Thêm mật khẩu trước
          this.mData.dataForm1.command = "AddPassword";
          this.mData.dataForm1.agent_id = this.getAgentId();
          this.mData.dataForm1.params = [ip, pw, this.dataConfig.connectionMode || "auto"];

          try {
            const addPwIdRes = await CommandQueueApi.create(this.mData.dataForm1);
            const addPwResult = await this.fn_waitForCommand(addPwIdRes.result, 35000);

            if (addPwResult && addPwResult.result && typeof addPwResult.result === 'string') {
              if (addPwResult.result.includes('code : 153')) {
                window.toastr.error('Tài khoản bị khoá tạm thời (Mã lỗi 153), vui lòng đợi mở khoá hoặc khởi động lại máy chấm công.');
                this.isGetcommandHasData = true;
                return;
              }
              if (addPwResult.result.includes('code : 41')) {
                window.toastr.error('Hikvision lỗi 41 (Hết tài nguyên / Quá tải kết nối): Máy chấm công đang bận hoặc vượt quá số kết nối tối đa. Vui lòng tắt iVMS/SADP/trình duyệt đang kết nối máy chấm công, hoặc khởi động lại (reboot) máy chấm công (hoặc thử chọn Phương thức kết nối: ISAPI).', '', { timeOut: 10000 });
                this.isGetcommandHasData = true;
                return;
              }
              if (addPwResult.result.includes('code : 29')) {
                window.toastr.error('Hikvision SDK lỗi 29: Thiết bị từ chối thao tác hoặc phiên kết nối đang bận. Hãy tắt iVMS/SADP/Agent cũ và khởi động lại máy chấm công.', '', { timeOut: 8000 });
                this.isGetcommandHasData = true;
                return;
              }
              if (addPwResult.result.includes('code : 1')) {
                window.toastr.error('Mật khẩu thiết bị không chính xác (Mã lỗi 1: NET_DVR_PASSWORD_ERROR). Vui lòng kiểm tra lại mật khẩu.');
                this.isGetcommandHasData = true;
                return;
              }
              if (addPwResult.result.includes('code : 7')) {
                window.toastr.error('Không thể kết nối mạng tới thiết bị (Mã lỗi 7: NET_DVR_NETWORK_FAIL_CONNECT). Vui lòng kiểm tra lại địa chỉ IP và dây mạng.');
                this.isGetcommandHasData = true;
                return;
              }
            }

            if (!addPwResult || !addPwResult.is_success) {
              const extraErr = (addPwResult && addPwResult.result && typeof addPwResult.result === 'string') ? ` (${addPwResult.result})` : '';
              window.toastr.error('Mật khẩu của thiết bị nhập chưa đúng hoặc không thể kết nối tới thiết bị.' + extraErr);
              this.isGetcommandHasData = true;
              return;
            }

            // Bước 2: Đồng bộ thời gian thiết bị (truyền kèm mật khẩu để Agent login chuẩn xác)
            if (formattedTime) {
              this.mData.dataForm2.command = "SetDeviceTime";
              this.mData.dataForm2.agent_id = this.getAgentId();
              this.mData.dataForm2.params = [ip, formattedTime, pw];

              try {
                const setTimeIdRes = await CommandQueueApi.create(this.mData.dataForm2);
                await this.fn_waitForCommand(setTimeIdRes.result, 20000);
              } catch (e) {
                // Không chặn thành công nếu set thời gian bị lỗi nhỏ
              }
            }

            window.toastr.success(`Cấu hình thiết bị ${ip} thành công !`);
            this.fn_resetForm("myForm");
            this.mData.dialogConfig = false;
            this.isGetcommandHasData = true;

            await this.fn_getListDevice();
            await this.fn_commandGetDataTable();
          } catch (error) {
            window.toastr.error('Có lỗi xảy ra khi cấu hình thiết bị !');
            this.isGetcommandHasData = true;
          }
        } else {
          // Thiết bị đã có mật khẩu, chỉ cập nhật thời gian
          this.mData.dataForm2.command = "SetDeviceTime";
          this.mData.dataForm2.agent_id = this.getAgentId();
          this.mData.dataForm2.params = (pw && typeof pw === 'string' && pw.trim() !== '' && !pw.includes('*'))
            ? [ip, formattedTime, pw]
            : [ip, formattedTime];

          try {
            const setTimeIdRes = await CommandQueueApi.create(this.mData.dataForm2);
            const setTimeResult = await this.fn_waitForCommand(setTimeIdRes.result, 25000);

            if (setTimeResult && setTimeResult.is_success) {
              window.toastr.success(`Đồng bộ thời gian thiết bị ${ip} thành công !`);
            } else {
              let errMsg = `Có lỗi xảy ra khi đồng bộ thời gian thiết bị ${ip}!`;
              if (setTimeResult && setTimeResult.result && typeof setTimeResult.result === 'string') {
                if (setTimeResult.result.includes('code : 41')) {
                  errMsg = `Hikvision SDK lỗi 41 (Hết tài nguyên / Quá tải kết nối): Máy chấm công đang bận phiên kết nối. Hãy khởi động lại máy chấm công.`;
                } else if (setTimeResult.result.includes('code : 29')) {
                  errMsg = `Hikvision SDK lỗi 29: Phiên kết nối thiết bị đang bận hoặc từ chối thao tác. Hãy khởi động lại máy chấm công.`;
                } else if (setTimeResult.result.includes('code : 153')) {
                  errMsg = `Tài khoản máy chấm công bị khoá tạm thời (Mã lỗi 153).`;
                }
              }
              window.toastr.error(errMsg, '', { timeOut: 8000 });
            }

            this.fn_resetForm("myForm");
            this.mData.dialogConfig = false;
            this.isGetcommandHasData = true;

            await this.fn_getListDevice();
            await this.fn_commandGetDataTable();
          } catch (error) {
            window.toastr.error('Có lỗi xảy ra khi cấu hình thiết bị !');
            this.isGetcommandHasData = true;
          }
        }
      });
    },

    fn_checkSuccessAddPwAndTime() {
      const isSuccess = this.isHasPw
        ? this.configTimeDeviceStatus
        : (this.configPasswordStatus && this.configTimeDeviceStatus);
      const targetIp = this.mData.ipDeviceConfig || (this.$router.currentRoute.query ? this.$router.currentRoute.query.ip : "") || "";

      if (isSuccess) {
        window.toastr.success(`Cấu hình thiết bị ${targetIp} thành công !`);
      } else if (this.isErrorAddPasswordCommandQueue) {
        window.toastr.error(`Tài khoản bị khoá, vui lòng đợi tài khoản mở khoá hoặc khởi động lại máy chấm công.`);
      } else if (!this.configPasswordStatus && !this.isHasPw) {
        window.toastr.error(`Mật khẩu của thiết bị nhập chưa đúng, vui lòng nhập lại.`);
      } else {
        window.toastr.error(`Có lỗi xảy ra khi cấu hình thiết bị ${targetIp}!`);
      }
      this.fn_resetForm("myForm");
      this.mData.dialogConfig = false;
      this.isSuccess = false;
    },

    async fn_showHideDeviceNameDialog(e, id, name) {
      this.mData.dialogUpdateDeviceName = true;
      this.dataConfigDeviceName.id = id;
      this.dataConfigDeviceName.name = name ? name : "";
      if (!this.dataConfigDeviceName.id) {
        this.dataAddDevice = {
          agent_id: this.getAgentId(),
          conpany_id: this.mData.dataDefault.currentCompany.id,
          ip: e.ip,
          serial: e.serial,
          password: e.password,
          is_active: true
        };
      }
    },

    fn_updateDeviceName() {
      this.$refs["formRenameDevice"].validate(async (valid) => {
        if (valid) {
          try {
            if (!this.dataConfigDeviceName.id) {
              this.dataAddDevice.name = this.dataConfigDeviceName.name.trim();
              await DeviceApi.create(this.dataAddDevice);
            } else {
              this.dataConfigDeviceName.name = this.dataConfigDeviceName.name.trim();
              await DeviceApi.update({
                id: this.dataConfigDeviceName.id,
                name: this.dataConfigDeviceName.name,
              });
            }
            await this.fn_getListDevice();
            this.dataAllDevices.forEach(device => {
              if (device.id == this.dataConfigDeviceName.id) {
                device.name = this.dataConfigDeviceName.name;
                return;
              }
            });
            this.$refs["formRenameDevice"].resetFields();
            this.mData.dialogUpdateDeviceName = false;
          } catch (error) {
            // console.error(error);
          }
        }
      });
    },

    fn_showHidePw(index, mode) {
      if (mode == "show") {
        this.dataPwDevice[index].isShowPw = true;
      } else if (mode == "hide") {
        this.dataPwDevice[index].isShowPw = false;
      }
    },
    //event table
    fn_tableSelectionChange(val) {
      var _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function (element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_changeData(data) {
      data.forEach((item) => {
        if (item.is_active) {
          item.isOpen = item.disabled ? false : true;
          item.isActive = item.is_active;
        }
      });
      return data;
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },

    fn_resetForm(refName) {
      this.$refs[refName].resetFields();
    },

    closeDialog() {
      this.dataConfig = {
        pw: undefined,
        timeDevice: undefined,
      };
      this.$refs.myForm.clearValidate();
    },

    fn_cancelGetDataDevices() {
      this.isGetcommandHasData = true;
      if (!this.dataTable || this.dataTable) {
        clearInterval(this.mData.refreshGetResultTable);
        clearTimeout(this.timeOutNoData);
      }
      if (!this.dataDevice || this.dataDevice) {
        clearInterval(this.mData.refreshGetResult);
      }
      if (!this.timePushDataDevice || this.timePushDataDevice) {
        clearInterval(this.mData.refreshGetTimePushDataResult);
      }
      if (!this.dataAddedEmployees || this.dataAddedEmployees) {
        clearInterval(this.mData.refreshGetAddedEmployees);
      }
      clearTimeout(this.setTimeoutGetResultTable);
      clearInterval(this.mData.refreshGetResultAddPw);
      clearInterval(this.mData.refreshGetResultSetDeviceTime);
      sessionStorage.clear();
      this.refreshGetDataDevice();
    },

    async fn_syncEmployee(deviceIp) {
      if (this.isProcessFiveMins) {
        clearInterval(this.refreshGetResultTable);
        this.refreshGetDataDevice();
      }

      this.$confirm(
        "Hệ thống sẽ thực hiện đồng bộ nhân viên xuống máy chấm công.",
        "Thông báo",
        {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning",
        }
      )
        .then(async () => {
          try {
            const response = await EmployeeApi.syncEmployees(deviceIp);
            const result = response && response.result;
            if (!result || !result.success || !result.queuedCount) {
              window.toastr.error((result && result.message) || "Không tạo được lệnh đồng bộ nhân viên.");
              return;
            }
            window.toastr.success(`Đã tạo ${result.queuedCount} lệnh đồng bộ cho ${result.employeeCount} nhân viên.`);
            this.listDataPerPage = [];
            sessionStorage.clear();
          } catch (error) {
            window.toastr.error("Gửi yêu cầu đồng bộ nhân viên thất bại.");
          }
        })
        .catch(() => {});
    },

    async fn_getAddedEmployee(ip) {
      if (this.isProcessFiveMins) {
        clearInterval(this.refreshGetResultTable);
        this.refreshGetDataDevice();
      }
      this.ip = ip;
      this.mData.dataFormGetAddedEmployee.command = "GetAddedEmployees";
      this.mData.dataFormGetAddedEmployee.agent_id =
        this.getAgentId();
      this.mData.dataFormGetAddedEmployee.params = [
        this.ip,
        this.mData.tableRules.page,
        this.mData.tableRules.limit,
      ];
      const commandDetail = this.mData.dataFormGetAddedEmployee;
      const idCommandRes = await CommandQueueApi.create(commandDetail, true);
      const res = await this.fn_findByIdCommandGet(idCommandRes.result);
      if (!res || !res.result.result) {
        this.fn_startIntervalGetDataAddedEmployees(idCommandRes.result);
      }
      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "Admin-Timekeeping-TimekeepingConfig-AgentConnectionManagement",
            query: {
              limit: this.mData.tableRules.limit,
              page: this.mData.tableRules.page,
              ip: this.ip,
            },
          })
          .catch((err) => {
            // console.log(err);
          });
      }
      setTimeout(() => {
        this.isGetcommandHasData = true;
        clearInterval(this.mData.refreshGetAddedEmployees);
      }, 5 * 60 * 1000);
    },

    fn_openDialogDeleteDevice(rowData) {
      this.idRecordDelete = rowData.id;
      this.dialogDeleteDevice = true;
    },

    async fn_deleteDevice(id) {
      try {
        await DeviceApi.delete(id)
        if (this.isProcessFiveMins) {
          clearInterval(this.refreshGetResultTable);
          this.fn_reLoadData();
        } else  {
          await this.fn_getListDevice()
        }
        this.dialogDeleteDevice = false;
      } catch (error) {
        window.toastr.error('Xóa thiết bị thất bại.')
      }
    },

    fn_timeOut() {
      clearTimeout(this.timeOutNoData);
      this.timeOutNoData = setTimeout(() => {
        this.isGetcommandHasData = true;
        clearInterval(this.mData.refreshGetResultTable);
        clearInterval(this.mData.refreshGetTimePushDataResult);
      }, 30 * 1000);
    },

    fn_reLoadData() {
      this.isProcessFiveMins = true;
      if (!this.dataTable || this.dataTable) {
        clearInterval(this.mData.refreshGetResultTable);
        clearTimeout(this.timeOutNoData);
        clearTimeout(this.setTimeoutGetResultTable);
        clearTimeout(this.intervalGetListDevice);
      }
      this.isSuccess = false;
      this.fn_commandGetDataTable();
      this.fn_timeOut();
      this.refreshGetDataDevice();
      this.listDataPerPage = [];
      sessionStorage.clear();
    },

    refreshGetDataDevice() {
      this.isSuccess = false;
      this.setTimeoutGetResultTable = setTimeout(async () => {
        clearInterval(this.mData.refreshGetResultTable);
        await this.fn_commandGetDataTable();
        await this.fn_timeOut();
        await this.refreshGetDataDevice();
        this.listDataPerPage = [];
        sessionStorage.clear();
      }, 5 * 60 * 1000);
    },

    fn_tableSizeChange(limit) {
      this.clicked = true;
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(1);
    },

    fn_tableCurentChange(page) {
      if (!this.clicked) {
        this.fn_tableChangeOffset(page);
      }
    },

    fn_tablePrevClick(page) {
      this.clicked = false;
    },

    fn_tableNextClick(page) {
      this.clicked = false;
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.dataAddedEmployees = [];
      if (
        this.listDataPerPage.includes(
          "limit=" +
            this.mData.tableRules.limit +
            "-page=" +
            this.mData.tableRules.page +
            "-ip=" +
            this.ip
        )
      ) {
        this.dataAddedEmployees = JSON.parse(
          sessionStorage.getItem(
            "limit=" +
              this.mData.tableRules.limit +
              "-page=" +
              this.mData.tableRules.page +
              "-ip=" +
              this.ip
          )
        );
        this.clicked = false;
        if (this.mData.tableRules.showUrl) {
          this.$router
            .replace({
              name: "Admin-Timekeeping-TimekeepingConfig-AgentConnectionManagement",
              query: {
                limit: this.mData.tableRules.limit,
                page: this.mData.tableRules.page,
                ip: this.ip,
              },
            })
            .catch((err) => {
              // console.log(err);
            });
        }
      } else {
        this.fn_getAddedEmployee(this.ip);
        this.clicked = false;
      }
    },

    fn_backToDefault(done) {
      this.listDataPerPage = [];
      this.mData.tableRules.page = 1;
      this.mData.tableRules.offset = 0;
      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "Admin-Timekeeping-TimekeepingConfig-AgentConnectionManagement",
          })
          .catch((err) => {
            // console.log(err);
          });
      }
      done();
    },

    fn_clearAllSetTime() {
      if (!this.dataTable || this.dataTable) {
        clearInterval(this.mData.refreshGetResultTable);
        clearTimeout(this.timeOutNoData);
      }
      if (!this.dataDevice || this.dataDevice) {
        clearInterval(this.mData.refreshGetResult);
      }
      if (!this.timePushDataDevice || this.timePushDataDevice) {
        clearInterval(this.mData.refreshGetTimePushDataResult);
      }
      if (!this.dataAddedEmployees || this.dataAddedEmployees) {
        clearInterval(this.mData.refreshGetAddedEmployees);
      }
      clearTimeout(this.setTimeoutGetResultTable);
      clearInterval(this.mData.refreshGetResultAddPw);
      clearInterval(this.mData.refreshGetResultSetDeviceTime);
      clearInterval(this.intervalGetListDevice);
    },

    fn_setInterValGetListDevice() {
      this.intervalGetListDevice = setInterval(() => {
        this.fn_getListDevice();
      }, 60 * 1000);
    }
  },

  //run after render view
  async created() {
    await this.fn_clearAllSetTime();
    await this.fn_getListDevice();
    this.fn_reLoadData();
  },
  mounted() {},

  destroyed() {
    this.fn_clearAllSetTime();
  },
  watch: {
    // Thời gian đẩy công
    timePushDataDevice() {
      if (this.timePushDataDevice) {
        this.isGetcommandHasData = true;
        clearInterval(this.mData.refreshGetTimePushDataResult);
        // clearTimeout(this.timeOutNoDataTimePush);
        this.mData.dialogSettingAgent = !this.mData.dialogSettingAgent;
      }
    },
    // Thời gian thiết bị khi click 'Cấu hình'
    dataDevice() {
      if (this.dataDevice && this.dataDevice.result) {
        this.mData.dialogConfig = !this.mData.dialogConfig;
        clearInterval(this.mData.refreshGetResult);
        this.momentEndGetDeviceTime = new Date().getTime();
        const timeDeviceGet = JSON.parse(this.dataDevice.result).Result
          .listTime;
        if (timeDeviceGet.length != 0) {
          const timeDevice = new Date(
            JSON.parse(this.dataDevice.result).Result.listTime[0].deviceTime
          ).getTime();
          this.dataConfig.timeDevice = new Date(
            this.momentEndGetDeviceTime -
              this.momentEndGetDeviceTime +
              timeDevice
          );
        }
      }
    },
    // Data Nhân viên được thêm trên thiết bị
    dataAddedEmployees() {
      if (this.dataAddedEmployees && this.isSuccess) {
        this.isGetcommandHasData = true;
        clearInterval(this.mData.refreshGetAddedEmployees);
        this.mData.dialogAddedEmployees = true;
      }
    },
    dataTable() {
      if (this.dataTable) {
        this.dataPwDevice = [];
        this.dataTable.forEach(() => {
          this.dataPwDevice.push({ isShowPw: false });
        });
        if (this.isSuccess) {
          clearInterval(this.mData.refreshGetResultTable);
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .dialog-employee {
  .el-dialog {
    margin-top: 5% !important;
    .el-dialog__body {
      min-height: calc(100vh - 340px);
      max-height: calc(100vh - 320px);
      overflow-y: auto;
    }
  }
}
.btnCancel {
  position: fixed;
  top: 55%;
  left: 50%;
  z-index: 10000;
  transform: translateX(-50%);
}
.icon-Establish {
  font-size: 15px;
  margin-left: 0;
}
::v-deep .el-dialog {
  margin-top: 10vh !important;
}
::v-deep .fake_p .el-input input {
  border-color: transparent;
  background-color: transparent;
  box-shadow: none;
}
::v-deep .fake_p .el-input input:hover {
  border-color: #c0c4cc;
  background-color: #fff;
}
::v-deep .fake_p .el-input input:focus {
  border-color: rgba(250, 164, 4, 0.5);
  background-color: #fff;
  box-shadow: none;
}
::v-deep .content {
  overflow: hidden;
  text-overflow: ellipsis;
}
::v-deep .dialog-warning {
  .el-dialog__body {
    padding: 0px !important;
  }
  .el-dialog__header {
    background-color: #fff !important;
    border-bottom: 1px solid #fff !important;
  }
}
@media (max-width: 1920px) {
  ::v-deep .content {
   max-width: 200px;
  }
}
@media (max-width: 1600px) {
  ::v-deep .content {
   max-width: 150px;
  }
}
@media (max-width: 1440px) {
  ::v-deep .content {
   max-width: 125px;
  }
}
@media (max-width: 1366px) {

  ::v-deep .content {
   max-width: 120px;
  }
}
@media (max-width: 1200px) {
  ::v-deep .content {
   max-width: 110px;
  }
}
</style>
